import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { formatWorkflowDate, parseWorkflowDate } from "./workflowRunData";

interface WorkflowDateFieldProps {
  label?: string;
  id?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
}

/** Same DatePicker the rest of the portal uses: small, full width, calendar-only (read-only input). */
const WorkflowDateField: React.FC<WorkflowDateFieldProps> = ({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  error = false,
}) => (
  <DatePicker
    label={label}
    value={parseWorkflowDate(value)}
    onChange={(date) => onChange(formatWorkflowDate(date))}
    disabled={disabled}
    slotProps={{
      textField: {
        id,
        size: "small",
        fullWidth: true,
        required,
        error,
        inputProps: { readOnly: true },
      },
    }}
  />
);

export default WorkflowDateField;
